import Box from "@mui/material/Box";
import { DASH } from "../../lib/constants.js";
import EditableField from "../EditableField.js";

export default function Event({ isEditing, locales, onChange, plot = {} }) {
  const handleChange =
    (field) =>
    ({ target }) => {
      onChange({ field, value: target.value });
    };

  return (
    <Box display="flex" flexDirection="column">
      <EditableField
        id="event-title"
        isEditing={isEditing}
        label={locales["plot.event.title"]}
        onChange={handleChange("eventName")}
        text={plot.eventName}
        value={plot.eventName ?? ""}
        variant="body1"
      />
      <EditableField
        id="event-time"
        isEditing={isEditing}
        label={locales["plot.event.time.edit"]}
        onChange={handleChange("eventTime")}
        text={`${locales["plot.event.time.noEdit"]} ${plot.eventTime ?? DASH}`}
        value={plot.eventTime ?? ""}
        variant="body2"
      />
      <EditableField
        id="event-location"
        isEditing={isEditing}
        label={locales["plot.event.location.edit"]}
        onChange={handleChange("eventLocation")}
        text={`${locales["plot.event.location.noEdit"]} ${
          plot.eventLocation ?? DASH
        }`}
        value={plot.eventLocation ?? ""}
        variant="body2"
      />
    </Box>
  );
}
